// Translated by FANJT2024

import login from './login';

export default {
  language: 'zh',
  country: 'cn',
  name: '中文',
  embeddedLocale: login,
  flags: ['CN'],
};
